import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteBreakPartsInput = {
  logId: number;
  itemId: number;
  partId: number;
};

export const useDeleteBreakPartsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsItemsBrakesParts>>,
      QueryError,
      DeleteBreakPartsInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ logId, itemId, partId }: DeleteBreakPartsInput) => {
      return VhcRecordLogService.deleteVhcRecordsItemsBrakesParts(logId, itemId, partId);
    },
    {
      ...options
    }
  );
